// extracted by mini-css-extract-plugin
module.exports = {"styleGuideContainer":"style-guide_styleGuideContainer__xdfW6"};